/**
 * headerTheme.js
 *
 * Central color/style constants for the new top header + popovers.
 * Change values here to retheme the whole header without touching
 * any component logic.
 */
export const headerTheme = {
  navIconColor: '#E24B4A',          // was inline red, now a token
  navIconChipBg: '#f0eaf7',
  headerHeight: '70px',        
  // Top header bar
  headerBg: '#0d0d12',
  headerBorder: '#2a2a35',
  headerTitleColor: '#5fc4e8',

  // Hamburger / avatar trigger buttons
  triggerBg: '#1f1f29',
  triggerBgHover: '#2a2f37',
  triggerIconColor: '#e8e8ed',

  // Popover panel (shared by nav menu + profile menu)
  popoverBg: 'linear-gradient(160deg, #2a1a3d, #1a0f2a)', // was flat #1a1a22
  popoverBorder: 'rgba(168, 127, 219, 0.25)',   
  popoverShadow: '0 12px 32px rgba(0,0,0,0.45)',
  popoverText: '#e8e8ed',
  popoverTextMuted: '#9a87b8',
  popoverDivider: '#2a2a35',
  popoverHoverBg: 'rgba(168, 127, 219, 0.15)',
  // NEW — profile popover now themed via tokens instead of hardcoded CSS
  profilePopoverGradientStart: '#2a1a3d',
  profilePopoverGradientEnd: '#1a0f2a',
  profilePopoverBorder: 'rgba(168, 127, 219, 0.25)',
  profilePopoverAccent: '#a87fdb',      // icons, muted text base hue
  profilePopoverMutedBg: '#3a2654',     // select + muted button bg

  // Buttons inside popovers
  dangerBg: '#ff5d5d',
  dangerBgHover: '#ff7575',
  dangerText: '#ffffff',
  // NEW — danger button gradient + shadow as tokens
  dangerOutlineColor: '#f0a8a6',
  dangerOutlineBorder: '#e2807e',
  dangerOutlineHoverBg: 'rgba(226, 128, 126, 0.12)',

  // Avatar ring
  avatarRing: '#5fc4e8',

  // Border radius / spacing tokens
  radiusSm: '8px',
  radiusMd: '14px',
  radiusFull: '999px',
};